module.exports = __webpack_public_path__ + "static/media/wound_token.185bb801.png";